import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import isArchived from 'archive/isArchived';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import Modal from 'ui-library/modals/Modal';

import CopyAnalysisKeyButton from './CopyAnalysisKeyButton';

interface ThirdPartyImportExportModalProps {
  analysis: PipelineGraphQL;
  onRequestSubmit: () => void;
  onRequestClose: () => void;
}

export default function ThirdPartyImportExportModal({
  analysis,
  ...modalProps
}: ThirdPartyImportExportModalProps): JSX.Element {
  return (
    <Modal
      title="Connect with external tool"
      {...modalProps}
      buttons={[
        {
          submit: true,
          text: 'Close',
        },
      ]}
    >
      <div className={css(styles.modalText)}>
        Send or receive data from an external analytics tool. Depending on your connection, you may need an
        Analysis key.
      </div>
      <CopyAnalysisKeyButton analysisId={analysis.id} disabled={isArchived(analysis)} />
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalText: {
    ...FONT_PROXIMA_13,
    marginBottom: 11,
  },
});
